export default __webpack_public_path__ + "media/images/document-dossier-g2149-papier-rouge-icone-9620-96-5a2e72e18bef8f9508aa8dd747b3ad8e.png";